// extracted by mini-css-extract-plugin
export default {"color":"styles_color__aaqhE"};